var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99988 1V17",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6364 3.90906H6.18181C5.50671 3.90906 4.85926 4.17724 4.3819 4.6546C3.90453 5.13197 3.63635 5.77942 3.63635 6.45451C3.63635 7.12961 3.90453 7.77705 4.3819 8.25442C4.85926 8.73179 5.50671 8.99997 6.18181 8.99997H9.81817C10.4933 8.99997 11.1407 9.26815 11.6181 9.74551C12.0954 10.2229 12.3636 10.8703 12.3636 11.5454C12.3636 12.2205 12.0954 12.868 11.6181 13.3453C11.1407 13.8227 10.4933 14.0909 9.81817 14.0909H3.63635",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.a484ea0d44d2c58bfab899225d16ce4d.svg";
export { ForwardRef as ReactComponent };